// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__kN26s","footer":"styles_footer__IRgUj"};